// extracted by mini-css-extract-plugin
export var orderDetails = "_qc-2";
export var orderImage = "_qc-1";
export var orderMeta = "_qc-3";
export var orderSummary = "_qc-0";
export var rightArrow = "_qc-4";